import {
  ae
} from "./chunk.Q25FCJRM.js";
import {
  Linkable
} from "./chunk.ABOYTYJO.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// node_modules/lit-html/directives/choose.js
var rr = (r2, o, t) => {
  for (const t2 of o) if (t2[0] === r2) return (0, t2[1])();
  return t?.();
};

// src/components/jb-search-result-item/jb-search-result-item.scss?inline
var jb_search_result_item_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
article {
  position: relative;
}
article::before, article::after {
  bottom: 0;
  content: "";
  height: 1px;
  position: absolute;
  width: 100%;
  z-index: 101;
}
article::before {
  background: rgba(20, 30, 85, 0.2);
}
article::after {
  background: #141e55;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.8s ease-in-out;
}
article:hover::after {
  transform: scaleX(1);
  transition-duration: 0.5s;
}

/* stylelint-disable */
/* stylelint-enable */
.category {
  font-family: var(--theme-font-bold-family, VerlagSSm, Tahoma, sans-serif);
  font-weight: var(--theme-font-bold-weight, 700);
}

h5, slot {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

slot {
  color: rgba(var(--rgb-primary, 20, 30, 85), var(--text-opacity, var(--theme-opacity-80, 0.8)));
  font-size: 1rem;
  line-height: 1.625rem;
}

.category {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 0.688rem;
  letter-spacing: 0.063rem;
  line-height: 1rem;
}

h5 {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 1.313rem;
  line-height: 2.125rem;
}
@media (min-width: 1281px) {
  h5 {
    font-size: 1.5rem;
    line-height: 2.25rem;
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
}

article {
  display: flex;
  flex-direction: column;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  padding: 30px 0 0;
  transform: translateZ(0);
}
@media (min-width: 960px) {
  article {
    flex-direction: row;
    padding: 34px 0 0;
  }
}

.category {
  color: #a2a5bb;
  display: inline-block;
  margin-bottom: 16px;
  padding: 0;
  pointer-events: initial;
  position: relative;
  text-transform: uppercase;
  width: 140px;
}
@media (min-width: 960px) {
  .category {
    margin-bottom: 0;
  }
}

a {
  display: inline-block;
  text-decoration: none;
  width: 100%;
}

h5 {
  font-size: 24px;
  font-size: 1.5rem;
  margin-bottom: 12px;
}

slot {
  -webkit-box-orient: vertical;
  display: block;
  -webkit-line-clamp: 4;
  margin-bottom: 20px;
  max-height: 104px;
  overflow: hidden;
}
@media (min-width: 960px) {
  slot {
    -webkit-line-clamp: 3;
    margin-bottom: 24px;
    max-height: 80px;
  }
}

.content-wrap {
  display: block;
  max-width: 100%;
  overflow-x: hidden;
  padding-left: 0;
  width: 100%;
}

ul {
  display: inline-block;
  padding-left: 24px;
}

.news,
.article,
.page {
  padding-bottom: 30px;
}
@media (min-width: 960px) {
  .news,
  .article,
  .page {
    padding-bottom: 34px;
  }
}
.news breadcrumb-item,
.article breadcrumb-item,
.page breadcrumb-item {
  margin-bottom: 16px;
}

.page,
.article {
  display: flex;
  flex-wrap: nowrap;
  position: relative;
  white-space: nowrap;
}
.page::before,
.article::before {
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 90%, white);
  content: "";
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
}
.page jb-date,
.article jb-date {
  margin-right: 28px;
  padding-top: 2px;
}
.page jb-breadcrumbs,
.article jb-breadcrumbs {
  flex-grow: 1;
}

jb-language-item {
  padding: 0 15px;
  position: relative;
}
jb-language-item:first-of-type {
  padding-left: 0;
}
jb-language-item::after {
  background-color: rgb(var(--rgb-primary, 20, 30, 85));
  border-radius: 100%;
  content: "";
  height: 3px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
}
jb-language-item:last-of-type::after {
  content: none;
}

jb-date {
  display: inline-block;
}

jb-breadcrumbs {
  display: block;
  margin-bottom: 0;
}

jb-breadcrumbs-item {
  display: none;
  padding-left: 0;
}
jb-breadcrumbs-item:not(:first-of-type) {
  --padding-left: 24px;
}
jb-breadcrumbs-item:nth-last-child(2) {
  --dot-display: none;
}
@media (min-width: 600px) {
  jb-breadcrumbs-item {
    display: inline-block;
  }
  jb-breadcrumbs-item:nth-last-child(2) {
    --dot-display: block;
  }
}
jb-breadcrumbs-item:nth-last-child(2), jb-breadcrumbs-item:nth-last-child(3) {
  display: inline-block;
}`;

// src/components/jb-search-result-item/jb-search-result-item.ts
var JbSearchResultItem = class extends Linkable(h) {
  _trackClick() {
    this.dispatchEvent(
      new CustomEvent("jb-search:result", {
        detail: this,
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke`<article>
      <div class="category">${this.category}</div>
      <div class="content-wrap">
        <a
          data-linkable
          @click=${this._trackClick}
        >
          <h5>${ae(this.headline)}</h5>
        </a>
        <a
          data-linkable
          @click=${this._trackClick}
        >
          <slot></slot>
        </a>
        ${rr(
      this.category,
      [
        [
          "article",
          () => ke`<div class="article">
                  <a
                    data-linkable
                    @click=${this._trackClick}
                    ><jb-date
                      .date=${this.date.date}
                      .time=${this.date?.time}
                    ></jb-date
                  ></a>
                </div>`
        ],
        [
          "news",
          () => ke`<div class="news">
                  <jb-date
                    .date=${this.date.date}
                    .time=${this.date?.time}
                  ></jb-date>
                  <ul>
                    ${this.languages?.map(
            (language) => ke`<jb-language-item
                          .text=${language.text}
                          .link=${language.link}
                        ></jb-language-item>`
          )}
                  </ul>
                </div>`
        ],
        [
          "page",
          () => ke`<div class="page">
                  <a
                    data-linkable
                    @click=${this._trackClick}
                  >
                    <jb-breadcrumbs>
                      ${this.breadcrumbItems?.map(
            (breadcrumb) => ke`<jb-breadcrumbs-item
                            slot="items"
                            .text=${breadcrumb.text}
                            .link=${breadcrumb.link}
                          ></jb-breadcrumbs-item>`
          )}
                    </jb-breadcrumbs>
                  </a>
                </div>`
        ]
      ],
      () => ke`<strong>Category: ${this.category} not found</strong>`
    )}
      </div>
    </article>`;
  }
};
JbSearchResultItem.styles = r(jb_search_result_item_default);
__decorateClass([
  n({ type: Array })
], JbSearchResultItem.prototype, "breadcrumbItems", 2);
__decorateClass([
  n()
], JbSearchResultItem.prototype, "category", 2);
__decorateClass([
  n({ type: Object })
], JbSearchResultItem.prototype, "date", 2);
__decorateClass([
  n()
], JbSearchResultItem.prototype, "headline", 2);
__decorateClass([
  n({ type: Number })
], JbSearchResultItem.prototype, "index", 2);
__decorateClass([
  n({ type: Array })
], JbSearchResultItem.prototype, "languages", 2);
__decorateClass([
  n({ type: Object })
], JbSearchResultItem.prototype, "link", 2);
JbSearchResultItem = __decorateClass([
  customElement("jb-search-result-item")
], JbSearchResultItem);

export {
  JbSearchResultItem
};
/*! Bundled license information:

lit-html/directives/choose.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
